/**
 * applyCaseConvert
 * apple case covert to axios client, the aim is using camel case in client side;
 * and using snake case when call Omnitech API
 */

import _ from 'lodash'
import snakeCaseKeys from '../../vendor/snakecase-keys'
import camelcaseKeys from '../../vendor/camelcase-keys'

export default function applyCaseConvert(instance) {
  // Add a response interceptor
  instance.interceptors.response.use(
    (response) => {
      response.data = camelcaseKeys(response.data, {
        deep: true,
        exclude: [
          /__[A-Za-z_]+/,
          /[|]+/,
        ],
        stopPaths: [
          'data.payment_request.payment_data.newebpay_params',
          'data.payment_request.payment_data.pay_params',
          'data.payment_request.payment_data.h5_pay_params',
          'data.payment_request.payment_data.pay2go_params'
        ]
      })
      return response
    },
    (error) => {
      const errorData = _.get(error, 'response.data', {})
      error = _.set(error, 'response.data', camelcaseKeys(errorData, { deep: true }))
      return Promise.reject(error)
    }
  )

  // Add a request interceptor
  instance.interceptors.request.use(
    (config) => {
      config = {
        ...config,
        data: snakeCaseKeys(config.data || {}, {exclude: [/__[A-Za-z_]+/, /[|]/, /h5_[a-z_]+/]}), // skip keys like `__try_decline_order`
        params: snakeCaseKeys(config.params || {}, {exclude: [/__[A-Za-z_]+/, /[|]/]}),
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  return instance
}
